import { render, staticRenderFns } from "./DiscountInformationRow.vue?vue&type=template&id=17aab761&scoped=true"
import script from "./DiscountInformationRow.vue?vue&type=script&lang=ts"
export * from "./DiscountInformationRow.vue?vue&type=script&lang=ts"
import style0 from "./DiscountInformationRow.vue?vue&type=style&index=0&id=17aab761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aab761",
  null
  
)

export default component.exports